import { Intercom, IntercomUserUpdateOptions } from '@capacitor-community/intercom';

import { capacitorService } from '../../application/CapacitorService';
import configuration from '../configuration';
import { Intercom as IntercomInterface } from './intercom';

/**
 * Capacitor Intercom: https://github.com/capacitor-community/intercom
 */
export class IntercomNative implements IntercomInterface {
  private _booted = false;
  boot() {
    Intercom.loadWithKeys({
      appId: configuration.INTERCOM_APP_ID,
      apiKeyAndroid: configuration.INTERCOM_ANDROID_API_KEY,
      apiKeyIOS: configuration.INTERCOM_IOS_API_KEY,
    });
    this._booted = true;
  }

  booted(): boolean {
    return this._booted;
  }

  async setUser({ userId, email }: { userId: string; email: string }) {
    await Intercom.registerIdentifiedUser({ userId, email });
  }

  async updateUser({ userId, email, phone, name, languageOverride, customAttributes }: IntercomUserUpdateOptions) {
    await Intercom.updateUser({
      userId,
      email,
      phone,
      name,
      languageOverride,
      customAttributes,
    });
  }

  open() {
    if (!capacitorService.isEmulator()) {
      Intercom.displayMessenger();
    }
  }

  logout() {
    Intercom.logout();
  }
}
